import { EVENT_MATCHES_EDIT_MODAL_HIDE, EVENT_MATCHES_EDIT_MODAL_SHOW } from '../../constants/action-types';
import { StoreState } from '../../interfaces';
import { initialStoreState } from './storeState';

export const storeReducer = (state: StoreState = initialStoreState, action: any): StoreState => {
  switch (action.type) {
    // ------ Modal Window Actions

    case EVENT_MATCHES_EDIT_MODAL_SHOW:
      return { ...state, editMatchesEventObject: action.event };

    case EVENT_MATCHES_EDIT_MODAL_HIDE:
      return { ...state, editMatchesEventObject: null };

    default:
      return state;
  }
};
